export const HERO = {
    eyebrow: 'Cine & Televisión · Cali',
    titleStart: 'Producción audiovisual y alquiler de equipos de ',
    titleAccent: 'cine y TV',
    titleEnd: ' en Cali',
    lead: 'Más de 40 años produciendo comerciales, programas de televisión, contenido institucional y eventos para marcas, agencias y entidades públicas en Colombia.',
    primaryCta: 'Cotizar por WhatsApp',
    secondaryCta: 'Ver servicios',
};

// Publishing the ISO 9001:2015 claim is blocked until the client confirms the certificate is current.
export const IS_ISO_CERTIFICATION_CONFIRMED = false;

export const GOOGLE_RATING = {
    score: '4.7',
    reviewCount: 136,
};

export const SERVICES = [
    {
        id: 'production',
        title: 'Producción audiovisual',
        text: 'Comerciales, institucionales, programas de televisión regional y nacional, videoclips y cubrimiento de eventos. Equipo técnico y creativo con experiencia en producciones cinematográficas.',
    },
    {
        id: 'rental',
        title: 'Alquiler de equipos',
        text: 'Cámaras FullHD, 2K y 4K, iluminación HMI, ópticas y lentes fijos Carl Zeiss y Canon. Alquiler por día o por temporada, con soporte técnico.',
    },
    {
        id: 'advisory',
        title: 'Asesoría y venta de equipos',
        text: 'Diseño, importación y puesta en marcha de proyectos de cine, multimedia, TV HD, streaming y automatización de canales de televisión.',
    },
    {
        id: 'events',
        title: 'Producción técnica de eventos',
        text: 'Montaje, logística y realización audiovisual para eventos corporativos, sociales e institucionales de cualquier tamaño.',
    },
];

export const EQUIPMENT = {
    lead: 'Cámaras FullHD, 2K y 4K, iluminación HMI y ópticas Carl Zeiss y Canon. Alquiler por día o por temporada, con soporte técnico.',
    categories: ['Cámaras', 'Ópticas', 'Iluminación', 'Sonido', 'Grip y soporte', 'Streaming'],
    cta: 'Consulta disponibilidad y tarifas',
};

export const TRACK_RECORD = {
    title: 'Cuatro décadas detrás de cámara',
    text: 'Desde 1985 trabajamos para grandes marcas a través de las agencias de publicidad más reconocidas, que se apoyan en nuestra capacidad técnica, infraestructura y equipo creativo. Hemos producido para entidades como Emcali y participamos de forma recurrente en convocatorias de Telepacífico.',
    stats: [
        { id: 'founded', value: '1985', label: 'Año de fundación' },
        { id: 'rating', value: '4.7', label: '136 reseñas en Google', hasStar: true },
        { id: 'team', value: '20+', label: 'Profesionales en el equipo' },
    ],
};

// Set videoId to '' to hide the whole portfolio section (e.g. while the client picks another video).
export const REEL = {
    videoId: 'l1WcjC6f5Ww',
    title: 'Reel Televicentro del Valle',
    channelLabel: 'Ver más en YouTube',
};
